import { render, staticRenderFns } from "./therapy.vue?vue&type=template&id=6aea4597&scoped=true&"
import script from "./therapy.vue?vue&type=script&lang=js&"
export * from "./therapy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea4597",
  null
  
)

export default component.exports